import PositivoPlusCNPJQuery from "../queries/PositivoPlusCNPJQuery";
import PositivoPlusCPFQuery from "../queries/PositivoPlusCPFQuery";
import SerasaPremiumCPFQuery from "../queries/SerasaPremiumCPFQuery";
import SerasaPremiumCNPJQuery from "../queries/SerasaPremiumCNPJQuery";
import CompletaPlusCNPJForm from "../forms/CompletaPlusCNPJForm";
import LeilaoPositivoQuery from "../queries/autos/LeilaoPositivoQuery";
import SerasaBasicoQuery from "../queries/SerasaBasicoQuery";
import ScrBacenScoreQuery from "../queries/ScrBacenScoreQuery";
import CompletaVeicularQuery from "../queries/CompletaVeicularQuery";
import AcertaCompletoCPFQuery from "../queries/AcertaCompletoCPFQuery";
import DefineLimiteQuery from "../queries/DefineLimiteQuery";
import DefineLimitePositivoQuery from "../queries/DefineLimitePositivoQuery";

export const componentsMap = {
  PositivoPlusCPFQuery,
  PositivoPlusCNPJQuery,
  CompletaPlusCNPJForm,
  SerasaPremiumCPFQuery,
  SerasaPremiumCNPJQuery,
  LeilaoPositivoQuery,
  SerasaBasicoQuery,
  ScrBacenScoreQuery,
  CompletaVeicularQuery,
  AcertaCompletoCPFQuery,
  DefineLimiteQuery,
  DefineLimitePositivoQuery,
};
